module.exports = __webpack_public_path__ + "img/my-avatar.fa303886.png";